import { render, staticRenderFns } from "./LoginError.vue?vue&type=template&id=32af5643&"
import script from "./LoginError.vue?vue&type=script&lang=js&"
export * from "./LoginError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VParallax } from 'vuetify/lib/components/VParallax';
installComponents(component, {VParallax})
